import React, { useEffect, useRef, useState } from "react";
import { Select } from "antd";

import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";

import * as Types from "../commons/typeDTO";
import * as Request from "../commons/request";

function SelectUser({
    value,
    onChange,
    onChangeInfo,
}: {
    value?: string;
    onChange?: (value: string) => void;
    onChangeInfo?: (value: Types.UserDto) => void;
}) {
    const { Option } = Select;
    const [users, setUsers] = useState<Array<Types.UserDto>>([]);
    const debounceTimer = useRef<ReturnType<typeof setTimeout>>();

    const requestAxiosGetUsers = async (keyWord: string) => {
        const response = await utilAxiosWithAuth().get(Request.USERS_URL, {
            params: { isUser: true, keyWord, page: 0, size: 30 },
        });
        return response.data;
    };

    const { loading: loadingGetUsers, error: errorGetUsers, data: resultGetUsers, execute: requestGetUsers } = useAsyncAxios(requestAxiosGetUsers);

    useEffect(() => {
        if (resultGetUsers === null) return;
        setUsers(resultGetUsers.users.content);
    }, [resultGetUsers]);

    useEffect(() => {
        if (errorGetUsers === null) return;
        console.log("errorGetUsers", errorGetUsers);
    }, [errorGetUsers]);

    const handleSearch = (searchValue: string) => {
        if (debounceTimer.current) {
            clearTimeout(debounceTimer.current);
        }

        if (!searchValue || searchValue.length < 2) {
            setUsers([]);
            return;
        }

        debounceTimer.current = setTimeout(() => {
            requestGetUsers(searchValue);
        }, 300);
    };

    const onChangeUser = (value: string) => {
        onChange !== undefined && onChange(value);

        const data = users.filter((user) => user.phone === value)[0];
        onChangeInfo !== undefined && onChangeInfo(data);
    };

    return (
        <Select
            value={value}
            onChange={onChangeUser}
            onSearch={handleSearch}
            placeholder="이름 또는 연락처를 입력해 주세요."
            showSearch
            allowClear
            filterOption={false}
            loading={loadingGetUsers}
            notFoundContent={loadingGetUsers ? "검색 중..." : "검색어를 2자 이상 입력해 주세요."}
        >
            {users.length > 0
                ? users.map((option) => {
                      return (
                          <Option key={option.phone} value={option.phone}>
                              {option.name + " (" + option.phone.replace(/(\d{2,3})(\d{4})(\d{4})/, "$1-$2-$3") + ")"}
                          </Option>
                      );
                  })
                : null}
        </Select>
    );
}

export default SelectUser;
